import useIsKiosk from "@/shared/hooks/useIsKiosk";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PropsWithChildren } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      retryDelay: 2100,
    },
  },
});

const Providers = ({ children }: PropsWithChildren) => {
  const isKiosk = useIsKiosk();

  return (
      <QueryClientProvider client={queryClient}>
        {!isKiosk && (
          <ToastContainer
            newestOnTop
            position="bottom-right"
            pauseOnFocusLoss={false}
            pauseOnHover={false}
            limit={0}
            autoClose={2000}
          />
        )}
        {children}
      </QueryClientProvider>
  );
};

export default Providers;
